<div class="container">
  <div class="header-container">
    @if (clientDetailsVM(); as vm) {
      <svg-icon class="icon-container" [src]="vm.iconURL" [svgAriaLabel]="vm.type" svgClass="icon"></svg-icon>
      <div class="client-details">
        <div class="name-and-jurisdiction">
          <h1 class="client-name">{{vm.name}}</h1>
          <div class="client-jurisdiction">{{vm.jurisdiction}}</div>
        </div>
      </div>
    }
  </div>
  <app-tabs #tabsComponent [style]="'tabs'"></app-tabs>
  <div class="data-container">
    <router-outlet></router-outlet>
  </div>
</div>
